export const commonCs = {
  'Add': 'Přidat',
  'Back': 'Zpět',
  'Cancel': 'Zrušit',
  'Close': 'Zavřít',
  'Confirm': 'Potvrdit',
  'Continue': 'Pokračovat',
  'Create': 'Vytvořit',
  'Delete': 'Smazat',
  'Disconnect': 'Odpojit',
  'Edit': 'Upravit',
  'Finish': 'Dokončit',
  'Loading': 'Načítání',
  'Next': 'Další',
  'No': 'Ne',
  'None': 'Žádné',
  'OK': 'OK',
  'Open': 'Otevřít',
  'Refresh': 'Obnovit',
  'Remove': 'Odebrat',
  'Retry': 'Zkusit znovu',
  'Save': 'Uložit',
  'Saving...': 'Ukládání...',
  'Search': 'Hledat',
  'Select': 'Vybrat',
  'Send': 'Odeslat',
  'Skip': 'Přeskočit',
  'Status': 'Stav',
  'Update': 'Aktualizovat',
  'View': 'Zobrazit',
  'Yes': 'Ano',
  'Active': 'Aktivní',
  'Inactive': 'Neaktivní',
  'Enabled': 'Zapnuto',
  'Disabled': 'Vypnuto',
  'Connected': 'Připojeno',
  'Not connected': 'Nepřipojeno',
  'Pending': 'Čeká',
  'Approved': 'Schváleno',
  'Rejected': 'Zamítnuto',
  'Completed': 'Dokončeno',
  'Failed': 'Selhalo',
  'Error': 'Chyba',
  'Success': 'Hotovo',
  'Unknown': 'Neznámé',
  'Today': 'Dnes',
  'Tomorrow': 'Zítra',
  'Yesterday': 'Včera',
  'Name': 'Jméno',
  'Email': 'E-mail',
  'Password': 'Heslo',
  'Description': 'Popis',
  'Title': 'Název',
  'Actions': 'Akce',
  'Settings': 'Nastavení',
  'Open navigation': 'Otevřít navigaci',
  'Close navigation': 'Zavřít navigaci',
  'Close navigation overlay': 'Zavřít navigační vrstvu',
  'Something went wrong. Please try again.': 'Něco se pokazilo. Zkuste to prosím znovu.',
  'Request failed': 'Požadavek se nezdařil',
  'Session expired': 'Relace vypršela',
  'No results found.': 'Nebyly nalezeny žádné výsledky.',
  'No data yet.': 'Zatím nejsou žádná data.',
  'Please try again.': 'Zkuste to prosím znovu.',
  'Confidence': 'Jistota',
  'Language': 'Jazyk',
  'Download': 'Stáhnout',
  'App could not load this screen': 'Aplikace nemohla načíst tuto obrazovku',
  'Unexpected frontend error': 'Neočekávaná chyba aplikace',
  'Reload': 'Načíst znovu',
  'Open app': 'Otevřít aplikaci',
  'same origin / not configured': 'stejný origin / nenastaveno',
  'empty': 'prázdné',
};
